module.exports = __webpack_public_path__ + "static/media/brands.68d14079.jpeg";